import { render, staticRenderFns } from "./modelDetail.vue?vue&type=template&id=f29d3ade&scoped=true"
import script from "./modelDetail.vue?vue&type=script&lang=js"
export * from "./modelDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/modelDetail.scss?vue&type=style&index=0&id=f29d3ade&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29d3ade",
  null
  
)

export default component.exports